import React, { Fragment, useEffect } from "react";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useLocation, useNavigate } from "react-router-dom";
import ResendOtpButton from "../../../form/ResendOtpButton";
import { useMutation } from "@tanstack/react-query";
import Form from "../../../form/Form";
import { otpVerification, sendOtp } from "../../../../services/authService";
import Input from "../../../form/Input";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const OtpVerificationForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const { callback } = Object.fromEntries(params.entries());

  const autoCountDown = location?.state?.autoCountDown;
  const email = location?.state?.email;

  const { values, handleChange, handleSubmit, errors, formValidate } = useForm({
    validationRules: validation,
    initialState: { email: email },
  });

  useEffect(() => {
    if (!location?.state?.email) {
      navigate(`/login${callback ? "?callback=" + callback : ""}`);
    }
  }, [location?.state]);

  const { mutate: onSubmit, isPending: signUpPending } = useMutation({
    mutationFn: async (val) => {
      return await otpVerification({
        ...val,
        requestType: "SIGNUP",
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        if (res?.data?.hasPassword === false) {
          navigate(
            `/reset-password${callback ? "?callback=" + callback : ""}`,
            {
              state: { email: location?.state?.email, ...res?.data },
            }
          );
        } else {
          navigate(`/login${callback ? "?callback=" + callback : ""}`);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
  });

  const {
    mutate: handleOtpResend,
    isPending: resendOtpPending,
    data: otpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await sendOtp({
        email: val?.email,
        requestType: "SIGNUP",
        verificationType: "email-verification",
      });
    },
    onSuccess: async (res) => {
      if (res.status >= 200 && res.status < 300) {
        toast.success(res?.message);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
  });

  return (
    <Form onSubmit={onSubmit} handleSubmit={handleSubmit} className="space-y-4">
      <Fragment>
        <div className="flex gap-4">
          {email && (
            <div className="relative flex gap-2 items-center">
              <h4 className="font-bold text-base">Email:</h4>{" "}
              <p className="text-sm">{email}</p>
            </div>
          )}

          <ResendOtpButton
            onResend={() => {
              const isEmailValid = !errors?.email;
              if (isEmailValid && values?.email) {
                handleOtpResend({ email: values.email });
              } else {
                handleChange({
                  target: { name: "email", value: values.email },
                });
              }
            }}
            isPanding={resendOtpPending}
            otpData={otpData}
            autoCountDown={autoCountDown}
          />
        </div>
        <OtpInput
          handleOtpChange={(val) =>
            handleChange({
              target: { value: val, name: "otp" },
            })
          }
          label={"Enter the code to confirm"}
          inputName="otp"
          labelChildClass={"!rounded-lg !border-white focus:!border-primary"}
          {...formValidate(errors, "otp")}
        />
      </Fragment>
      <div className="relative">
        <Button
          buttonLabel={"Verify Account"}
          buttonType="submit"
          buttonLabelClasses={"!text-lg !font-semibold"}
          buttonClasses={"!w-full !h-12 !rounded-lg"}
          loading={signUpPending}
          isDisable={signUpPending}
          buttonIconPosition="left"
        />
      </div>
    </Form>
  );
};

export default OtpVerificationForm;
